module.exports = __webpack_public_path__ + "static/media/main3_zh.dcb8b726.jpg";